import { createSlice } from '@reduxjs/toolkit';
import { getPowerBIUrlForPageId } from './power-bi-async-thunks';

const powerBISlice = createSlice({
  name: 'power-bi',
  initialState: {
    pageIdToPowerBIUrlMap: {},
    fetchingURL: false
  },
  reducers: {},
  extraReducers: (builder) =>
    builder
      .addCase(getPowerBIUrlForPageId.pending, (state) => {
        state.fetchingURL = false;
      })
      .addCase(getPowerBIUrlForPageId.rejected, (state) => {
        state.fetchingURL = false;
      })
      .addCase(getPowerBIUrlForPageId.fulfilled, (state, action) => {
        state.pageIdToPowerBIUrlMap = {
          ...state.pageIdToPowerBIUrlMap,
          ...action.payload
        };
        state.fetchingURL = false;
      })
});

export default powerBISlice;
